import React, { useState, useEffect, useRef, Suspense } from "react";
import Container from "react-bootstrap/Container";
import Slider from "react-slick";
import VideoModal from "../Video/VideoModal";
import { StyledModal } from "../Video/styles";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./PresentationCarousel.css";

export default function Body({ langClass = null }) {
  const [play, setPlay] = useState(false);
  const [selectedVideoId, setSelectedVideoId] = useState("");
  const [videoData, setVideoData] = useState([]);
  const [language, setLanguage] = useState("en");

  // Ref for the Slick carousel
  const sliderRef = useRef(null);

  // Function to handle video toggling
  const videoToggle = (videoId) => {
    const isOpening = !play;
  
    if (isOpening) {
      document.body.classList.add("no-scroll-presentation-modal");
      if (sliderRef.current) {
        sliderRef.current.slickPause();
      }
    } else {
      document.body.classList.remove("no-scroll-presentation-modal");
      if (sliderRef.current) {
        sliderRef.current.slickPlay();
      }
    }
  
    setPlay(isOpening);
    setSelectedVideoId(videoId);
  };
  

  useEffect(() => {
    return () => {
      document.body.classList.remove("no-scroll-presentation-modal");
    };
  }, []);

  // Fetch video data from JSON based on the current language
  useEffect(() => {
    const path = window.location.pathname;
    const currentLanguage = path.includes("/es") ? "es" : "en";
    setLanguage(currentLanguage);

    fetch(process.env.REACT_APP_CDN_LINK + "ussaic/PresentationCarousel/PresentationCarousel.json?t=" + Date.now())
      .then((response) => response.json())
      .then((data) => {
        // Access the Videos array from the JSON structure
        setVideoData(data.Videos || []);
      })
      .catch((error) => {

        setVideoData([]); // Set empty array on error
      });
  }, []);

  // Slick carousel settings
  const settings = {
    draggable: true,
    speed: 1250,
    autoplaySpeed: 3000,
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    swipe: true,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 2560,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false, // Hides arrows on smaller screens
        },
      },
    ],
  };

  return (
    <>
      <div className="videofreecredit">
      <div className="presentations-changes-div">
            <p className="presentations-changes-div-text">Presentations</p>
         </div>
        <Container>
        
          {videoData.length > 0 && (
            <>
              <Slider {...settings} ref={sliderRef} className="video-carousel presentation-carousel-memories-changes">
                {videoData.map((video, index) => (
                  <div key={index} onClick={() => videoToggle(video.videoId)}>
                    <img
                      src={video.path}
                      srcSet={`
                        ${video.path}?w=400 400w,
                        ${video.path}?w=800 800w,
                        ${video.path}?w=1200 1200w
                      `}
                      sizes="(max-width: 600px) 400px, (max-width: 1024px) 800px, 1200px"
                      className="img-fluid bcarousalThumbnail"
                      loading="lazy"
                      alt={video.alt}
                      width="600" 
                      height="400"
                    />
                  </div>
                ))}
              </Slider>
              <div className="presentation-carousel-controls">
                <button
                  className="presentation-carousel-arrow prev"
                  onClick={() => sliderRef.current?.slickPrev()}
                  aria-label="Previous"
                >
                  <ChevronLeft size={20} />
                </button>
                <button
                  className="presentation-carousel-arrow next"
                  onClick={() => sliderRef.current?.slickNext()}
                  aria-label="Next"
                >
                  <ChevronRight size={20} />
                </button>
              </div>
            </>
          )}
        </Container>
      </div>

      <Suspense fallback={<div />}>
        <StyledModal show={play}>
          <VideoModal onClose={() => videoToggle("")} videoId={selectedVideoId} />
        </StyledModal>
      </Suspense>
    </>
  );
}